import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-stepper-icon',
  templateUrl: './stepper-icon.component.html',
  styleUrls: ['./stepper-icon.component.scss'],
})
export class StepperIconComponent {
  @Input() index: number = 0;
  @Input() active: boolean = false;
  @Input() completed: boolean = false;

  constructor(private sanitizer: DomSanitizer) {}

  getSafeIconUrl(): SafeResourceUrl {
    const iconName = this.getIconName();
    const url = `assets/icons/${iconName}.svg`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getIconName(): string {
    switch (this.index) {
      case 0:
        return 'identification';
      case 1:
        return 'monitor';
      case 2:
        return 'phone';
      case 3:
        return 'sync';
      case 4:
        return 'settings';
      default:
        return 'identification';
    }
  }

  getIconAlt(): string {
    switch (this.index) {
      case 0:
        return 'Identification Step';
      case 1:
        return 'Monitor Step';
      case 2:
        return 'Phone Step';
      case 3:
        return 'Sync Step';
      case 4:
        return 'Settings Step';
      default:
        return 'Step Icon';
    }
  }
}
